import getRequest from '../utils/getRequest.js';
import Cookies from 'js-cookie'  
import {logout} from '../io/api.js'
import {getCookieInfo,clearAllCookie} from './getCookie.js' 
let token = getRequest(window.location.search)['token'] || '';
let loginType=localStorage.getItem('loginType')||Cookies.get('loginType')||'';
import {axiosTimer } from './axiosTimer.js'
import Vue from 'vue'
import { Message } from 'element-ui'; 
import axios from '../assets/js/axios.config.js';
Vue.prototype.$message = Message; 

let cancelTokens =[]; // 存储所有请求的 CancelToken
export const requestInter = (fetch) => {
    fetch.interceptors.request.use(function (config) {
        if(loginType){
            config.headers["X-Login-T"] = loginType;
        }
        config.headers["userfrom"] = 'tcmkb'
        token =  localStorage.getItem('token') ||getCookieInfo('access_token')||'';
        let refreshToken=window.localStorage.getItem("refresh_token")||getCookieInfo('refresh_token')||''; 
        // 创建 CancelToken，并存储到数组中   
        config.cancelToken = new axios.CancelToken(cancel => {
            cancelTokens.push(cancel);
        });
        
        if(token){ 
            config.headers["Authorization"] = 'bearer' +token ; 
            if(refreshToken){
                axiosTimer(refreshToken)
            }
        } 
        
         let $loadingBox = document.querySelector('.loading-box');
         $loadingBox && ($loadingBox.style.display = 'flex');
        
         return config;
     }, function (error) { 
        return Promise.reject(error);
     });
}
let isUnauthorized = false; // 全站 401 提示只弹一次（多接口并行时子组件会各自 $message）
// function isHomePagePath() {
//     const p = (window.location.pathname || '').replace(/\/+$/, '');
//     return p === '/knowservePlatform/homePage';
// }
function normalize401Data(payload) {
    const raw = payload && typeof payload === 'object' && !Array.isArray(payload) ? payload : {};
    return {
        ...raw,
        list: Array.isArray(raw.list) ? raw.list : [],
        indexList: Array.isArray(raw.indexList) ? raw.indexList : [],
    };
}
export const responseInter = (fetch) => {
    fetch.interceptors.response.use(function (response) {
        if (response && response.data && (response.data.code == 0 || response.data.code === '0')) {
            isUnauthorized = false;
        }
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');  
        //未登录的情况 
        if(response&&response.data&&response.data.code=='401'){
            response.data.msg = response.data.msg=='未授权,请登录'?'您的账号已退出或已在其他地方登录':response.data.msg;

            // /info 不占「首次提示」：原逻辑不弹框，仅静默为成功，避免与后续 401 竞态
            if (response.config.url == '/info') {
                response.data.code = 0;
                response.data.data = normalize401Data(response.data.data);
                return response;
            }
            if (isUnauthorized) {
                response.data.code = 0;
                response.data.data = normalize401Data(response.data.data);
                return response;
            }
            isUnauthorized = true;

            // if (isHomePagePath()) {
            //     Vue.prototype.$message.error({
            //         message: response.data.msg || '请求失败～',
            //         duration: 1500,
            //         type: 'error',
            //     });
            // } else {
                Vue.prototype.$message({
                    message: response.data.msg || '请求失败～',
                    duration: 1500,
                    type: 'error',
                    onClose: () => {
                        window.localStorage.clear();
                        window.sessionStorage.clear();
                        clearAllCookie();
                        window.localStorage.removeItem('refresh_token');
                        logout().then((res) => {
                            let data = res.data;
                            if (data && data.code == 0) {
                                window.open(`${location.origin}/knowservePlatform/homePage`, '_self');
                            } else {
                                Vue.prototype.$message.error(data.msg || '请求失败～');
                            }
                        });
                    },
                });
            // }
            response.data.code = 0;
            response.data.data = normalize401Data(response.data.data);
            return response;
        }   
        return response;
    }, function (error) {
        // 打印请求失败的接口信息
        console.log('请求失败接口:', error.config.url, '错误信息:', error.message);
        
        let $loadingBox = document.querySelector('.loading-box');
        $loadingBox && ($loadingBox.style.display = 'none');

        if (error.response && error.response.data && error.response.data.code == '101') {
            window.location.href = error.response.data.data.loginUrl;
        }
        
        return Promise.resolve(error.response);
        // return Promise.reject(error);
    });
}
